import { ApolloCache, Reference } from "@apollo/client";
import { ModifierDetails } from "@apollo/client/cache";

/**
 * Updates the Apollo cache after removing a favorite club.
 *
 * This function modifies the `getFavouriteClubsOfUser` field in the cache by filtering out
 * the club entry with the given `clubId`.
 *
 * @param clubId - The ID of the club to remove.
 * @returns A function that takes the Apollo cache object and performs the cache modification.
 */

export const updateCacheAfterFavouriteClubRemoval =
  (clubId: string) => (cache: ApolloCache<any>) => {
    cache.modify({
      fields: {
        getFavouriteClubsOfUser: (
          previous: readonly Reference[],
          { readField }: ModifierDetails
        ) => {
          return previous?.filter((d) => readField("clubId", d) !== clubId);
        },
      },
    });
  };
